import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const refreshApproval = async (data: any) => {
	const URL = `${API_URL}GetRefreshmentAllowancesByOrganisationID`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		refreshApprovalToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const calculateRefreshment = async (data: any) => {
	const URL = `${API_URL}CalculateRefreshmentAllowance`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		calculateRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const approveRefreshment = async (data: any) => {
	const URL = `${API_URL}ApproveRefreshmentAllowance`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		approveRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const bulkApproveRefreshment = async (data: any) => {
	const URL = `${API_URL}BulkApproveRefreshmentAllowances`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		bulkApproveRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const rejectRefreshment = async (data: any) => {
	const URL = `${API_URL}RejectRefreshmentAllowance`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		rejectRefreshmentToken: data,
	};
	return makeApiCall(URL, requestData);
};
